import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';
import deepmerge from 'deepmerge';

import useNotification from '../../../core/hooks/use_notification';
import { getDefaultPaginationQueryValues } from '../../../core/utils/api_utils';
import { getFoodPartnersNotificationData } from '../../../core/utils/notification_utils';
import PaginationControls from '../../common/pagination_controls';
import { getFoodPartnersAction, getFoodPartnersState } from '../../../features/food_partner/get_food_partners';
import FoodPartnersList from './food_partners_list';
import { Button } from '../../common/button';
import { ROUTE_FOOD_PARTNER_FORMS_NEW } from '../../../core/constants';
import PageHeader from '../../common/page_header';
import FoodPartnerFilters from './filters';

const initialQueryParams = {
    ...getDefaultPaginationQueryValues,
    query: ''
};

const FoodPartnersPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showErrorMessage } = useNotification();

    const getFoodPartners = useSelector(getFoodPartnersState);

    const [queryParams, setQueryParams] = useState(initialQueryParams);

    const refreshList = useCallback(() => {
        dispatch(getFoodPartnersAction(queryParams))
            .then(response => showErrorMessage(getFoodPartnersNotificationData(response)));
    }, [dispatch, queryParams, showErrorMessage]);

    useEffect(() => {
        refreshList();
    }, [dispatch, queryParams, refreshList, showErrorMessage]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader
                title="Dostawcy"
                actions={
                    <Button onClick={ () => navigate(ROUTE_FOOD_PARTNER_FORMS_NEW) }>
                        Dodaj dostawcę
                    </Button>
                }
            />

            <FoodPartnerFilters
                onClear={ () => setQueryParams(prevState => deepmerge(prevState, { query: '' })) }
                onSearchInputChange={ query => setQueryParams(prevState => deepmerge(prevState, { query })) }
            />

            { getFoodPartners?.loading && <LinearProgress/> }

            { getFoodPartners?.data?.content && (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <FoodPartnersList refreshList={ refreshList }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getFoodPartners?.data?.pageable?.pageNumber }
                            totalPages={ getFoodPartners?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            ) }

        </Box>
    );
};

export default FoodPartnersPage;